/**
 * Card processing surcharge — disabled; kept for optional re-enable via backend
 * STRIPE_CARD_PROCESSING_FEE_ENABLED and matching frontend flag below.
 */

export const CARD_PROCESSING_FEE_ENABLED = false;

export const CARD_PROCESSING_FEE_PERCENT = 0.0175;
export const CARD_PROCESSING_FEE_FIXED_AUD = 0.3;
export const CARD_PROCESSING_FEE_LABEL = "Card Processing Fee";

export const calculateCardProcessingFee = (amountBeforeFeeAud) => {
  if (!CARD_PROCESSING_FEE_ENABLED) {
    return 0;
  }

  const base = Number(amountBeforeFeeAud);
  if (!Number.isFinite(base) || base <= 0) {
    return 0;
  }

  const fee = base * CARD_PROCESSING_FEE_PERCENT + CARD_PROCESSING_FEE_FIXED_AUD;
  return Math.round(fee * 100) / 100;
};

export const calculateTotalWithCardProcessingFee = (amountBeforeFeeAud) => {
  const base = Number(amountBeforeFeeAud);
  if (!Number.isFinite(base) || base <= 0) {
    return 0;
  }

  return Math.round((base + calculateCardProcessingFee(base)) * 100) / 100;
};
